module.exports = __webpack_public_path__ + "media/luxury-2026/terrace-entry-960-f6bf7d7d.jpg";